module.exports = __webpack_public_path__ + "img/v3-location.7a2030e7.png";